import { render, staticRenderFns } from "./PageSettingsLanguages.vue?vue&type=template&id=745bd864&"
import script from "./PageSettingsLanguages.vue?vue&type=script&lang=js&"
export * from "./PageSettingsLanguages.vue?vue&type=script&lang=js&"
import style0 from "./PageSettingsLanguages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports